export default __webpack_public_path__ + "static/media/venmo.55292f7a.png";